import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Row, Col, Card, Switch } from "antd";
import Request from "../../request";
import { TableComp } from "sz-react-utils";


class BusinessReport extends React.Component {
    state = {
        lastFiveYears: [],
        counsellorsArr: [],
        countriesData: [],
        branchs: [],
        uniArr: [],
        dataYears: [2024]
    }


    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { dataYears } = this.state
            if (dataYears && dataYears.length > 0) {
                params.years = dataYears;
            }
            let response = await Request.getBusinessReportsByYear(params)
            return resolve(response)
        })
    }

    apiCounsellorRequest = (params) => {
        return new Promise(async (resolve) => {
            let { dataYears } = this.state
            if (dataYears && dataYears.length > 0) {
                params.years = dataYears;
            }
            let response = await Request.getBusinessReportsByCounsellor(params)
            return resolve(response)
        })
    }

    apiBranchWiseRequest = (params) =>{
        return new Promise(async(resolve)=>{
            let { dataYears } = this.state
            if (dataYears && dataYears.length > 0) {
                params.years = dataYears;
            }
            let response = await Request.getBusinessReportsByBranch(params)
            return resolve(response)
        })
    }

    apiCountryWiseRequest = (params) =>{
        return new Promise(async(resolve)=>{
            let { dataYears } = this.state
            if (dataYears && dataYears.length > 0) {
                params.years = dataYears;
            }
            let response = await Request.getBusinessReportsByCountry(params)
            return resolve(response)
        })
    }

    apiUniversityWiseRequest = (params) =>{
        return new Promise(async(resolve)=>{
            let { dataYears } = this.state
            if (dataYears && dataYears.length > 0) {
                params.years = dataYears;
            }
            let response = await Request.getBusinessReportsByUniversity(params)
            return resolve(response)
        })
    }

    reload = () => {
        this.table.current.reload()
        this.table1.current.reload()
        this.table2.current.reload()
    }


    updateDataYears = (checked, yearr) => {
        let dataYears = this.state.dataYears
        if (checked === true) {
            dataYears.push(yearr)
        } else if (checked === false) {
            dataYears = dataYears.filter(year => year !== yearr)
        }
        this.setState({ dataYears }, () => {
            this.reload()
        })
    }

    loadUniversities = () => {
        let params = {
            results: 10000,
            count: 10000
        }

        Request.getUniversities({ ...params }).then(resp => {
            resp.data = resp.data.reduce((temp, vv) => {
                temp.push({ id: vv._id, display: vv.universityInstitutionName })
                return temp
            }, [])
            this.setState({ uniArr: resp.data })
        })
    }

    loadBranches = () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ id: vv._id, display: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    loadCountries = () => {
        Request.getCountriesWithoutAuth({
            results: 200,
            sortField: 'countryName',
            sortOrder: 'ascend'
        })
            .then(resp => {
                let phoneCodes = [];
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.countryName });
                    return temp
                }, [])
                this.setState({ countriesData: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadCounsellors = async () => {
        let { data } = await Request.loadAllCounsellors()
        this.setState({ counsellorsArr: data })
    }

    getYears = () => {
        const currentYear = new Date().getFullYear();
        const lastFiveYears = [];

        for (let i = 0; i < 5; i++) {
            lastFiveYears.push(currentYear - i);
        }
        this.setState({ lastFiveYears })
    }
    componentDidMount() {
        this.loadUniversities()
        this.getYears()
        this.loadCounsellors()
        this.loadBranches()
        this.loadCountries()
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.table1 = React.createRef()
        this.table2 = React.createRef()
    }

    render() {
        const countryWisecolumns = [
            {
                title:'Country Name',
                key:'countryName'
            },
            {
                title: 'Total',
                key: 'totalLeads'
            },
            {
                title: 'Converted',
                key: 'convertedLeads',
            },
            {
                title: 'In Pipeline',
                key: 'pipelineLeads',
            },
            {
                title: "Visa Waiting",
                key: 'visaWaiting',

            },
            {
                title: "Visa Approved",
                key: 'visaApproved',

            },
            {
                title: 'Visa Refused',
                key: 'visaRefused',

            },
            {
                title: 'Enrolled In University',
                key: 'enrolledInUniversity'
            }
        ]
        const branchWisecolumns = [
            {
                title: 'Branch Name',
                key: 'branchName'
            },
            {
                title: 'Total',
                key: 'totalLeads'
            },
            {
                title: 'Converted',
                key: 'convertedLeads',
            },
            {
                title: 'In Pipeline',
                key: 'pipelineLeads',
            },
            {
                title: "Visa Waiting",
                key: 'visaWaiting',

            },
            {
                title: "Visa Approved",
                key: 'visaApproved',

            },
            {
                title: 'Visa Refused',
                key: 'visaRefused',

            },
            {
                title: 'Enrolled In University',
                key: 'enrolledInUniversity'
            }
        ]
        const counsellorWisecolumns = [
            {
                title: 'Counsellor Name',
                key: 'counsellorName'
            },
            {
                title: 'Total',
                key: 'totalLeads'
            },
            {
                title: 'Converted',
                key: 'convertedLeads',
            },
            {
                title: 'In Pipeline',
                key: 'pipelineLeads',
            },
            {
                title: "Visa Waiting",
                key: 'visaWaiting',

            },
            {
                title: "Visa Approved",
                key: 'visaApproved',

            },
            {
                title: 'Visa Refused',
                key: 'visaRefused',

            },
            {
                title: 'Enrolled In University',
                key: 'enrolledInUniversity'
            }
        ]
        const columns = [
            {
                title: 'Year',
                key: '_id'
            },
            {
                title: 'Total',
                key: 'totalLeads'
            },
            {
                title: 'Converted',
                key: 'convertedLeads',
            },
            {
                title: 'In Pipeline',
                key: 'pipelineLeads',
            },
            {
                title: "Visa Waiting",
                key: 'visaWaiting',

            },
            {
                title: "Visa Approved",
                key: 'visaApproved',

            },
            {
                title: 'Visa Refused',
                key: 'visaRefused',

            },
            {
                title: 'Enrolled In University',
                key: 'enrolledInUniversity'
            }
        ]
        let { lastFiveYears } = this.state
        return (
            <PageHeaderWrapper title="Overall Report">
                <Card bordered={false} style={{ marginBottom: 10 }}>
                    <Row>
                        {lastFiveYears && lastFiveYears.map((year, index) => (
                            <Col span={3}>
                                <Switch value={year} defaultChecked={this.state.dataYears.includes(year)} key={year} onChange={checked => {
                                    this.updateDataYears(checked, year)
                                }} /><strong style={{ marginLeft: 5 }}>{year}</strong>

                            </Col>
                        ))}
                    </Row>
                </Card>
                <Card title="Students" bordered={true} >
                    <Card title="Year Wise" style={{ marginBottom: 10 }}>
                        <TableComp
                            id={"overallReport"}
                            columns={columns}
                            ref={this.table}
                            useFixedHeader={true}
                            apiRequest={this.apiRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: false,
                                defaultPageSize: 20,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    <Card title="Counsellor Wise" style={{ marginBottom: 10 }}>
                        <TableComp
                            id={"overallReport"}
                            columns={counsellorWisecolumns}
                            ref={this.table1}
                            useFixedHeader={true}
                            apiRequest={this.apiCounsellorRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    <Card title="Branch Wise" style={{ marginBottom: 10 }}>
                        <TableComp
                            id={"overallReport"}
                            columns={branchWisecolumns}
                            ref={this.table2}
                            useFixedHeader={true}
                            apiRequest={this.apiBranchWiseRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    <Card title="Country Wise" style={{ marginBottom: 10 }}>
                        <TableComp
                            id={"overallReport"}
                            columns={countryWisecolumns}
                            ref={this.table2}
                            useFixedHeader={true}
                            apiRequest={this.apiCountryWiseRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                    <Card title="University Wise" style={{ marginBottom: 10 }}>
                        <TableComp
                            id={"overallReport"}
                            columns={countryWisecolumns}
                            ref={this.table2}
                            useFixedHeader={true}
                            apiRequest={this.apiUniversityWiseRequest}
                            // extraProps={{ scroll: { x: 1400 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 10,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                </Card>
            </PageHeaderWrapper>
        )
    }

}




const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BusinessReport)